import { store } from '@/store/main';
import { getChannelType } from '@/store/slices/user/selectors';
import { ChannelType } from '@/types/channel.types';
import isCurrentlyOnBrandTVDomain from '@/utils/navigation/is-currently-on-btv-domain';
import isCurrentlyOnWebinarPlusDomain from '@/utils/navigation/is-currently-on-webinarplus-domain';
import resetLoader from './reset-channel.loader';
import { authReady } from './main.loader';
import { getSubdomains } from '@/utils/get-subdomains';
import { getLeavePlatformLink } from '@/utils/navigation/get-leave-platform-link';

const pjdInternal = () => import.meta.env.VITE_FORCE_ADMIN === 'true' || window.bl__forceAdmin;

export async function channelGate() {
  if (pjdInternal()) {
    resetLoader();
    return;
  }

  await authReady;
  const channelType = getChannelType(store.getState());
  const isOnAdminView = window.location?.pathname?.startsWith('/admin');

  switch (channelType) {
    case ChannelType.BrandTV: {
      if (!isCurrentlyOnBrandTVDomain()) {
        const sub = getSubdomains(window.location.hostname);
        const newHost = `${sub}.${import.meta.env.VITE_BRAND_TV_DOMAIN}`;
        window.location.hostname = newHost;
      }
      break;
    }
    case ChannelType.Webinar: {
      if (!isCurrentlyOnWebinarPlusDomain()) {
        const sub = getSubdomains(window.location.hostname);
        const newHost = `${sub}.${import.meta.env.VITE_WEBINAR_PLUS_DOMAIN}`;
        window.location.hostname = newHost;
      }
      break;
    }
    case 'unset': {
      window.location.href = import.meta.env.VITE_EVENTS_APP_HOST;
      break;
    }
  }

  if (isOnAdminView) {
    window.location.href = getLeavePlatformLink();
  }

  resetLoader();
}
